import { render, staticRenderFns } from "./ActionBlock.vue?vue&type=template&id=1afd5ecb"
import script from "./ActionBlock.vue?vue&type=script&lang=js"
export * from "./ActionBlock.vue?vue&type=script&lang=js"
import style0 from "./ActionBlock.vue?vue&type=style&index=0&id=1afd5ecb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports